@if (isAssistant()) {
  <div class="w9-agent-row w9-agent-row--assistant">
    <div class="w9-agent-row__avatar"><sm-sonder-avatar [size]="16" /></div>
    <div class="w9-agent-row__col">
      @if (isTyping()) {
        <div class="w9-agent-row__typing" aria-label="Sonder is typing">
          <span></span><span></span><span></span>
        </div>
      } @else if (message.text) {
        <div class="w9-agent-row__bubble w9-agent-row__bubble--assistant"
             [innerHTML]="message.text | markdown"></div>
      }
    </div>
  </div>
} @else {
  <div class="w9-agent-row w9-agent-row--user">
    <div class="w9-agent-row__bubble w9-agent-row__bubble--user">{{ message.text }}</div>
    <div class="w9-agent-row__initials">{{ providerInitials }}</div>
  </div>
}
